import type { DashboardSnapshot } from "@/domain/model/Dashboard";
import type { DashboardService } from "@/domain/port/DashboardService";
import type { DashboardSnapshotResponseDto } from "./dto/DashboardDtos";
import { mapDashboardSnapshotResponseDtoToDomain } from "./mappers/DashboardMappers";
import type { HttpClient } from "@/infrastructure/HttpClient";

export class DashboardServiceImpl implements DashboardService {
  constructor(private readonly http: HttpClient) {}

  async getDashboardSnapshot(
    signal?: AbortSignal,
  ): Promise<DashboardSnapshot> {
    const dto = await this.http.request<DashboardSnapshotResponseDto>(
      "/api/dashboard",
      {
        method: "GET",
        signal,
      },
    );

    return mapDashboardSnapshotResponseDtoToDomain(dto);
  }
}
